"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = wrapWithErrorMonitoring;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _logError = _interopRequireDefault(require("ui-addon-upgrades/_core/common/reliability/logError"));

// Meant to be used sparingly, as high up as possible.
// `label` is not meant to match the function name. It goes to SFX.
function wrapWithErrorMonitoring(label, func) {
  (0, _invariant.default)(typeof label === 'string', '[wrapWithErrorMonitoring] argument `label` must be a string, got `%s`', (0, _typeof2.default)(label));
  (0, _invariant.default)(typeof func === 'function', '[wrapWithErrorMonitoring] argument `func` must be a function, got `%s`', (0, _typeof2.default)(func));
  return function monitoredFunc() {
    try {
      return func.apply(void 0, arguments);
    } catch (err) {
      (0, _logError.default)('ui-addon-upgrades', label);
      throw err;
    }
  };
}

module.exports = exports.default;